"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class ZigbeeFirmware extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'zigbeeFirmware';
        this._sku = initParams.sku;
        this._version = initParams.version;
    }
    set sku(value) {
        console.error('Do not set objects this way');
    }
    get sku() {
        return this._sku;
    }
    set version(value) {
        console.error('Do not set objects this way');
    }
    get version() {
        return this._version;
    }
}
exports.default = ZigbeeFirmware;
//# sourceMappingURL=zigbeeFirmware.js.map